<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="Perfect-Center"><span class="Bold">It is not normal behavior to kill and mutilate, in multiples, to satisfy an inner dark lust.</span></p>
<p class="Perfect-Center"><span class="Bold">This book is based on one simple question posed to over 70 of America’s most prolific Serial Killers:</span> <span class="Bold-Italic">Why did you kill?</span> <span class="Bold">Read the response from hand-written letters, court testimony, interviews, and interrogation statements that will give you, the Reader, an eye-opening insight into the mind of these monsters that walked among us.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword1.vue?198b9c80